import { Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ApiKey } from '../../shared/entities/apiKey/apiKey';
import * as fromGraphQl from './graphql';
import { NXDataSourcePrime } from '../../dataSource/NXDataSourcePrime';

export class ApiKeyDataSource extends NXDataSourcePrime<ApiKey> {
  constructor(
    apollo: Apollo,
    @Inject('env') environment: any
  ) {
    super(apollo, fromGraphQl.API_KEYS_QUERY, environment);
  }
  handleSubscriptionResult(data: fromGraphQl.ApiKeysQueryResponse): void {
    super.setSubject(
      data.apiKeys?.content ? data.apiKeys?.content : [],
      data.apiKeys?.totalElements ? data.apiKeys.totalElements : 0
    );
  }

  loadApiKeys(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
